module.exports = __webpack_public_path__ + "static/media/Steps.ad9a34a3.svg";